import React, { useState, useEffect } from 'react';
import "./HttpActionModalBody.css";
import ProgressBar from "./ProgressBar";
import { confirm_email, unsubscribe, notify } from '../api';


const HttpActionModalBody = ({ hideModal, page }) => {
    const [submitted, setSubmitted] = useState(false);
    const [infoMessage, setInfoMessage] = useState('');
    const [infoMessageClass, setInfoMessageClass] = useState('');
    const [isProgressStarted, setIsProgressStarted] = useState(false);

    useEffect(() => {
        let pleaseWaitMessage = null;
        let okMessage = null;
        let notOkMessage = null;
        if (page == "confirm_email") {
            pleaseWaitMessage = "Verific adresa, te rog așteaptă.";
            okMessage = "Emailul tău este confirmat. Lecția 1 este deja în inboxul tău — dacă nu o vezi, verifică folderul Spam sau Promoții. Următoarele lecții sosesc săptămânal.";
            notOkMessage = "Ceva nu a funcționat corect. Lasă-mi te rog un mesaj folosind butonul din dreapta sus.";
        }
        if (page == "unsubscribe") {
            pleaseWaitMessage = "Stocare modificări, te rog așteaptă.";
            okMessage = "Confirm dezabonarea. Nu vei mai primi emailuri.";
            notOkMessage = "Ceva nu a funcționat corect. Îmi pare rău. Lasă-mi te rog un mesaj folosind butonul din dreapta sus, sau dă un reply la oricare dintre email-urile primite de la mine şi voi rezolva manual.";
        }
        const handleHttpAction = async () => {
            const hash = window.location.hash;
            const queryString = hash.substring(hash.indexOf('?') + 1);
            const urlParams = new URLSearchParams(queryString);
            const id = urlParams.get('code');
            if (!id) {
                return;
            }
            setInfoMessage(pleaseWaitMessage)
            setInfoMessageClass('light')
            setIsProgressStarted(true);
            let response = null;
            try {
                if (page == "confirm_email") {
                    response = await confirm_email(id);
                }
                if (page == "unsubscribe") {
                    response = await unsubscribe(id);
                }
            } catch {
                notify(page + "_ERROR: " + id + " " + window.location);
                setInfoMessage(notOkMessage);
                setInfoMessageClass('danger');
                return;
            } finally {
                setIsProgressStarted(false);
                setSubmitted(true);
            }
            if (response.status == 200) {
                setInfoMessage(okMessage)
                setInfoMessageClass('success')
            }

        };

        handleHttpAction();
    }, []);

    const handleCancel = () => {
        setIsProgressStarted(false);
        hideModal();
    };

    return (
        <div className='mt-2 p-0 p-md-3'>
            <div style={{ width: '100%', textAlign: 'center' }}>
                {(infoMessage) && (<div id="infoModalMessage" style={{ fontSize: '120%' }} className={`mt-3 alert alert-${infoMessageClass}`}>{infoMessage}</div>)}
            </div>
            <ProgressBar isProgressStarted={isProgressStarted}></ProgressBar>

            {(submitted) && (
                <div className="d-flex justify-content-end">
                    <button disabled={!submitted || isProgressStarted} className="btn btn-primary m-2" onClick={handleCancel}>Închide</button>
                </div>
            )}
        </div>
    );
};

export default HttpActionModalBody;
